var React = require('react');
var DefaultLayout = require('./common/layout');
import '../public/less/login.less';
import { Link } from 'react-router';

const loginForm = React.createClass({
  render: function () {
    return (
      <div className='container'>
          <h2>You don't have authorization for this page.</h2>
      </div>
    )
  }
});

module.exports = loginForm;


// WEBPACK FOOTER //
// ./modules/noAuthorization.jsx